/**
 * 动画垂直滚动到页面指定位置
 * @param { Number } currentY 当前位置
 * @param { Number } targetY 目标位置
 */
// function scrollAnimation(currentY, targetY) {
//     // 获取当前位置方法
//     // const currentY = document.documentElement.scrollTop || document.body.scrollTop
  
//     // 计算需要移动的距离
//     let needScrollTop = targetY - currentY
//     let _currentY = currentY
//     setTimeout(() => {
//       // 一次调用滑动帧数，每次调用会不一样
//       const dist = Math.ceil(needScrollTop / 10)
//       _currentY += dist
//       window.scrollTo(_currentY, currentY)
//       // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
//       if (needScrollTop > 10 || needScrollTop < -10) {
//         scrollAnimation(_currentY, targetY)
//       } else {
//         window.scrollTo(_currentY, targetY)
//       }
//     }, 1)
//   }
    /*
    *定位页面目标元素到可视区域的减速滑动
    *作用类似却优于a标签锚点
    *@param targetPageY 目标元素位置(pageY)
    */
// function scrollAnimation (targetPageY,changeStatusFuc) {
//     let ratio = localStorage.getItem('ratio')
//     var timer=null;
//     clearInterval(timer);
//      timer = setInterval(function () {
//         var currentY = document.documentElement.scrollTop || document.body.scrollTop;//当前及滑动中任意时刻位置
//         var distance = targetPageY > currentY ? targetPageY - currentY : currentY - targetPageY;//剩余距离
//         var speed = Math.ceil(distance/10);//每时刻速度
//         if (((targetPageY-currentY)<=10&&(targetPageY-currentY)>=-10)||(targetPageY==currentY)) {
//             clearInterval(timer);
//             changeStatusFuc();
//         } else {
//             window.scrollTo(0,targetPageY > currentY ? currentY + speed : currentY - speed);
//         }
//     },10);
//     //  var scrollTop = $(this).scrollTop(); 
//     //  var documentHeight = $(document).height(); 
//     //  var windowHeight = $(window).height(); 
//     //  if (scrollTop + windowHeight == documentHeight){
//     //     //  document.getElementById("tip").style.display = "none";
//     //     clearInterval(timer);
//     //  }
//     //  if (scrollTop == 0){
//     //     //  document.getElementById("tip").style.display = "none";
//     //     clearInterval(timer);
//     //  }

// }

function scrollAnimation (targetPageY,changeStatusFuc) {
    var that = this
    var timer=null;
    clearInterval(timer);
     timer = setInterval(function () {
        var currentY = document.documentElement.scrollTop || document.body.scrollTop;//当前及滑动中任意时刻位置
        var distance = targetPageY > currentY ? targetPageY - currentY : currentY - targetPageY;//剩余距离
        var speed = Math.ceil(distance/10);//每时刻速度
        if (((targetPageY-currentY)<=10&&(targetPageY-currentY)>=-10)||(targetPageY==currentY)) {
            clearInterval(timer);
            // changeStatusFuc();
        } else {
            window.scrollTo(0,targetPageY > currentY ? currentY + speed : currentY - speed);
        }
    },10);
    var a = 0
    window.addEventListener("scroll", function(event)
    {
        event = event || window.event;
        var scrollTop = $(this).scrollTop(); 
        var documentHeight = $(document).height(); 
        var windowHeight = $(window).height();
        // console.log(scrollTop + windowHeight) 
        let num = detectZoom()
        if(num == 0.8){
            if (scrollTop + windowHeight == documentHeight-0.25){
                    // changeStatusFuc();
                clearInterval(timer);
                
            }
        }else{
            if (scrollTop + windowHeight == documentHeight){
                    // changeStatusFuc();
                clearInterval(timer);
               
            }
        }
       
    });
}
function detectZoom(){ 
    var ratio = 0,
      screen = window.screen,
      ua = navigator.userAgent.toLowerCase();
     if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
    }
    else if (ua.indexOf('msie')) {  
      if (screen.deviceXDPI && screen.logicalXDPI) {
        ratio = screen.deviceXDPI / screen.logicalXDPI;
      }
    }
    else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
      ratio = window.outerWidth / window.innerWidth;
    }
     
     if (ratio){
      ratio = Math.round(ratio * 100);
    }
     return ratio/100;
  }
module.exports = {
    scrollAnimation
}


//////////////////
// WEBPACK FOOTER
// ./static/utils.js
// module id = xffy
// module chunks = 46